// external
import Config from '../../utils/config';
import { region, brand } from '../../localizations/current-locale';
import { dynamicBrand } from '../../utils/brand';

// internal
import { valid, invalid } from '../../utils/validators/resolutions';
import stripDelimiter from '../../utils/strip-delimiter-from-currency';

// eslint-disable-next-line import/no-dynamic-require
let messages;
import(`../../utils/text-resources/${dynamicBrand()}/${region}/messages`).then((m) => {
  messages = m.default;
});

export const validateMonthlySalaryBeforeTax = (input = '', ...props) => {
  const cleanedInput = stripDelimiter(input);
  const config = Config.getValues();

  if (!/\S+/.test(cleanedInput || '')) {
    return (props[2] === 'applicant.monthlyIncomeBeforeTax'
      ? invalid(messages.monthlySalaryBeforeTaxRequired)
      : invalid(messages.coApplicantMonthlySalaryRequired));
  }

  if (!/^(-?\d+)$/.test(cleanedInput)) {
    return (props[2] === 'applicant.monthlyIncomeBeforeTax'
      ? invalid(messages.monthlySalaryOnlynumbers)
      : invalid(messages.coApplicantMonthlySalaryOnlynumbers));
  }

  const value = parseInt(cleanedInput, 10);

  const minSalary = config.RESTRICTIONS.MIN_SALARY;

  if (value < minSalary) {
    return (props[2] === 'applicant.monthlyIncomeBeforeTax'
      ? invalid(messages.monthlySalaryTooLow, { minSalary, brand })
      : invalid(messages.coApplicantMonthlySalaryTooLow, { minSalary, brand }));
  }

  return valid();
};

export const spouseMonthlyIncomeBeforeTaxValidator = (input = '', ...props) => {
  const cleanedInput = stripDelimiter(input);

  if (!/\S+/.test(cleanedInput || '')) {
    return (props[2] === 'applicant.spouseMonthlyIncomeBeforeTax'
      ? invalid(messages.spouseMonthlySalaryBeforeTaxRequired)
      : invalid(messages.coApplicantSpouseMonthlySalaryBeforeTaxRequired));
  }

  if (!/^(-?\d+)$/.test(cleanedInput)) {
    return (props[2] === 'applicant.spouseMonthlyIncomeBeforeTax'
      ? invalid(messages.spouseMonthlySalaryOnlynumbers)
      : invalid(messages.coApplicantSpouseMonthlySalaryOnlynumbers));
  }

  const value = parseInt(cleanedInput, 10);

  if (value < 0) {
    return (props[2] === 'applicant.spouseMonthlyIncomeBeforeTax'
      ? invalid(messages.spouseMonthlySalaryMustBePositive)
      : invalid(messages.coApplicantSpouseMonthlySalaryMustBePositive));
  }
  return valid();
};
